var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRightFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96301 14.0175L12.3372 11.6433C12.6947 11.2858 12.6947 10.7083 12.3372 10.3508L9.96301 7.97662C9.38551 7.40829 8.39551 7.81162 8.39551 8.62745V13.3666C8.39551 14.1916 9.38551 14.595 9.96301 14.0175Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightFilledIcon);
export default __webpack_public_path__ + "static/media/ChevronRightFilledIcon.66e556f08a16eea41a09075cf3610734.svg";
export { ForwardRef as ReactComponent };